"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconButton = _interopRequireDefault(require("@eig-builder/core-ui/IconButton"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _Menu = _interopRequireDefault(require("@eig-builder/core-ui/Menu"));

var _MenuItem = _interopRequireDefault(require("@eig-builder/core-ui/MenuItem"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: -10px;\n  margin-right: -12px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var KebabMenu = _styledComponents["default"].div(_templateObject());

var RowKebabMenu = function RowKebabMenu(_ref) {
  var actionCallback = _ref.actionCallback,
      options = _ref.options,
      item = _ref.item,
      menuIdentifier = _ref.menuIdentifier,
      pinRowKebabMenu = _ref.pinRowKebabMenu;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var onMenuItemClick = function onMenuItemClick(event, option) {
    event.stopPropagation();
    event.preventDefault();
    option["function"] && option["function"](item);
    var callback = actionCallback;

    if (callback && typeof callback === 'function') {
      callback(option);
    }

    handleClose();
  };

  var handleClose = function handleClose(event) {
    setAnchorEl(null);

    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
  };

  var handleClick = function handleClick(event) {
    if (!event) {
      return;
    }

    setAnchorEl(event.currentTarget);
    event.stopPropagation();
    event.preventDefault();
  };

  var open = Boolean(anchorEl);
  return options && /*#__PURE__*/_react["default"].createElement(KebabMenu, {
    className: pinRowKebabMenu ? 'custom-row-kebab-menu--pinned' : 'custom-row-kebab-menu'
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    dataElementId: "module--data-smp-grid--kebab-menu-".concat(menuIdentifier),
    dataElementLabel: "module--data-smp-grid--kebab-menu-".concat(menuIdentifier),
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    style: {
      height: '100%',
      "float": 'right'
    },
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "more_vert",
    "aria-owns": open ? 'long-menu' : undefined,
    "aria-haspopup": "true"
  })), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    id: "long-menu",
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose
  }, options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      dataElementId: "wle--card--kebab-menu-item-".concat(menuIdentifier, "-").concat(option.label),
      dataElementLabel: "wle--card--kebab-menu-item-".concat(menuIdentifier, "-").concat(option.label),
      dataElementLocation: _taggingHelper.DataElementLocations.POP_UP,
      key: option.key || option.label,
      onClick: function onClick(event) {
        return onMenuItemClick(event, option);
      }
    }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: "inherit"
    }, option.label));
  })));
};

RowKebabMenu.propTypes = {
  actionCallback: _propTypes["default"].func,
  item: _propTypes["default"].object.isRequired,
  menuIdentifier: _propTypes["default"].string,
  options: _propTypes["default"].array,
  pinRowKebabMenu: _propTypes["default"].bool
};
RowKebabMenu.defaultProps = {
  show: true,
  pinRowKebabMenu: false
};
var _default = RowKebabMenu;
exports["default"] = _default;